/**
 * A minimum set of complex number functions
 */
export default class C {
    constructor(public r: number, public i: number) {}
    public static g(r: number, i: number): C {
        return new C(r, i);
    };
    public polar(): C {
        return new C(Math.sqrt(this.r * this.r + this.i * this.i), Math.atan2(this.i, this.r));
    };
    public cartesian(): C {
        return new C(this.r * Math.cos(this.i), this.r * Math.sin(this.i));
    };
    public conj(): C {
        return new C(this.r, -this.i);
    };
    public mult(c: C): C {
        return new C(this.r * c.r - this.i * c.i, this.r * c.i + this.i * c.r);
    }
    public div(c: C): C {
        let det = c.r * c.r + c.i * c.i;
        return new C((this.r * c.r + this.i * c.i) / det, (this.i * c.r - this.r * c.i) / det);
        
    }
    public pow(c: C): C {
        if (c.i == 0) {
            if (c.r == -2) return new C(1, 0).div(this.mult(this));
            if (c.r == -1) return new C(1, 0).div(this);
            if (c.r == 0) return new C(1, 0);
            if (c.r == 1) return this;
            if (c.r == 2) return this.mult(this);
            if (c.r == 3) return this.mult(this.mult(this));
        }
        let mag = Math.sqrt(this.r * this.r + this.i * this.i);
        let t = Math.atan2(this.i, this.r);
        let re = Math.pow(mag, c.r) * Math.exp(-c.i * t) * Math.cos(c.r * t + c.i * Math.log(mag));
        let im = Math.pow(mag, c.r) * Math.exp(-c.i * t) * Math.sin(c.r * t + c.i * Math.log(mag));
        return new C(re, im);
    }
    public sqrt(): C {
        return this.pow(C.g(0.5, 0));
    };
    public sqrtCube(): C {
        return this.pow(C.g(1 / 3, 0));
    };
    public add(c: C): C {
        return new C(this.r + c.r, this.i + c.i);
    }
    public sub(c: C): C {
        return new C(this.r - c.r, this.i - c.i);
    }
};
